var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/img/icon4.png")}}),_c('router-link',{staticClass:"home ma-l-10",attrs:{"to":"/"}},[_vm._v("首页")]),_c('span',{staticClass:"ma-lr-10"},[_vm._v(">")]),_c('span',[_vm._v(_vm._s(_vm.$route.meta.title || "未设置标题"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }